(() => {
  if (window.fdCompactPurchaseLoaded) return;
  window.fdCompactPurchaseLoaded = true;
  function initialise() {
    if (!window.theme?.pubsub) return;
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, event => {
      const data = event.data;
      const root = document.getElementById(`ProductInfo-${data.sectionId}-${data.productId}`);
      if (!root?.hasAttribute('data-fd-compact')) return;
      root.querySelectorAll('.fd-ref-choice-amount').forEach(amount => {
        const updated = data.parsedHTML?.getElementById(amount.id);
        if (updated) amount.innerHTML = updated.innerHTML;
      });
      const id = `BuyButtonPrice-${data.sectionId}-${data.productId}`;
      const source = data.parsedHTML?.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        const button = destination.closest('button');
        button?.setAttribute('aria-label', destination.textContent.trim());
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
